export interface CoachEmployment {
	expertise: string[]
	patientCapacityLoad: number
	roleTypes: string[]
	roles: string[]
	skills: string[]
	startOfService: string
	title: number
}

export interface CoachExtra {
	active: boolean
	auth0UserId: string
	coachId: string
	firstLogin: boolean
	firstPassword: string
	organizationID: string
}

export interface CoachLocalization {
	carbs: string
	dateConfiguration: string
	glucoseLevel: string
	language: string
	temperature: string
	weightHeight: string
}

export interface CoachPersonal {
	cvUrl: string
	dateOfBirth: string
	email: string
	gender: string
	imageUrl: string
	name: string
	phone?: string
	firstName?: string
	lastName?: string
	state?: string
	Country?: string
}

export interface Coach {
	_id: string
	employment: CoachEmployment
	extra: CoachExtra
	localization: CoachLocalization
	numOfPatients: number
	organizations: any[]
	personal: CoachPersonal
	email: string
	ID: string
	account?: string | null
}

export interface CoachesDataTableModel {
	_id: string
	name: string
	capacityLoad: number
	date: string
	expertise: string
	title: string
	language: string
	organization: string
	role: string
	tier: string
	status: string
	email: string
}

export interface CoachesHistiryLogTableModel {
	_id: string
	action: string
	date: string
	patient: string
	notes: string
}

export interface SelectedCoachesDataTableModel extends CoachesDataTableModel {
	totalCapacity: number
	numOfPatients: number
}

export interface CoachDataRequest {
	name: string
	fromDade: string
	role: string
	team: string
	availability: string
	tier: string
	organization: string
}

export interface CoachHistoryLogRequest {
	activity?: string
	patientName?: string
	timestamp?: string
	userId: string
	skip: {
		[1]: number
		[2]: number
	}
	sort: {
		timestamp?: number
		activity?: number
	}
}

export interface HistoryLogCoachData {
	activity: string
	timestamp: string
	_id: string
	patientData: {
		name: string
	}
	accessedScreen: string
}

export interface AssignCoachDataTableModel {
	id: string
	name: string
	imageUrl?: string
	role: string
	language: string
	capacityLoad: number
	numOfPatients: number
	capacity: number
	country: string
	state: string
}

export enum SEARCH_COACHES_ACTION_TYPES {
	GET_ALL_COACHES = 'GET_ALL_COACHES',
	SELECTED_ASSIGN_COACH = 'SELECTED_ASSIGN_COACH',
	GET_COACH = 'GET_COACH',
	GET_COACH_HISTORY_LOG = 'GET_COACH_HISTORY_LOG',
	GET_COACH_HISTORY_LOG_SERCH = 'GET_COACH_HISTORY_LOG_SERCH',
	SET_ASSIGN_COACH_SEARCH_VALUE = 'SET_ASSIGN_COACH_SEARCH_VALUE',
	ASSIGN_COACH_SELECT = 'ASSIGN_COACH_SELECT',
	ASSIGN_COACH_LOADING = 'ASSIGN_COACH_LOADING',
	ASSIGN_COACH_RESET = 'ASSIGN_COACH_RESET',
}

export type CoachModelArrays = Array<Coach>

export interface SearchCoachesState {
	coachesDataArray: CoachModelArrays
	selectedAssignCoach: []
	selectedCoach: Coach
	historyLogCoach: HistoryLogCoachData[]
	historyLogCoachRequest: CoachHistoryLogRequest
	coachHistorySearch: string
	coachAssignSearch: string
	selectedCoachId: string
	assignCoachesLoading: boolean
}

export interface GetAllCoaches {
	type: SEARCH_COACHES_ACTION_TYPES.GET_ALL_COACHES
	payload: Array<Coach>
}

export interface GetCoach {
	type: SEARCH_COACHES_ACTION_TYPES.GET_COACH
	payload: Coach
}

export interface GetCoachHistoryLogSearch {
	type: SEARCH_COACHES_ACTION_TYPES.GET_COACH_HISTORY_LOG_SERCH
	payload: string
}

export interface SelectedAssignCoach {
	type: SEARCH_COACHES_ACTION_TYPES.GET_COACH_HISTORY_LOG
	payload: HistoryLogCoachData[]
}
export interface GetCoachHistoryLog {
	type: SEARCH_COACHES_ACTION_TYPES.SELECTED_ASSIGN_COACH
	payload: []
}

export interface CoachFilter {
	key: string
	value: string
}

export interface AppliedFilter {
	filter: CoachFilter
	params: CoachFilter[]
}

export interface AssignCoachSetSearchValueAction {
	type: SEARCH_COACHES_ACTION_TYPES.SET_ASSIGN_COACH_SEARCH_VALUE
	payload: string
}

export interface AssignCoachSelectAction {
	type: SEARCH_COACHES_ACTION_TYPES.ASSIGN_COACH_SELECT
	payload: string
}

export interface AssignCoachSetLoadingStateAction {
	type: SEARCH_COACHES_ACTION_TYPES.ASSIGN_COACH_LOADING
	payload: boolean
}

export interface AssignCoachesResetAction {
	type: SEARCH_COACHES_ACTION_TYPES.ASSIGN_COACH_RESET
}

export const FilterCoachesList: Array<CoachFilter> = [
	{
		key: 'languageRegion',
		value: 'Language',
	},
	{
		key: 'country',
		value: 'Country',
	},
	{
		key: 'state',
		value: 'State',
	},
]

export type SetCoachesAction =
	| GetAllCoaches
	| GetCoach
	| GetCoachHistoryLogSearch
	| SelectedAssignCoach
	| GetCoachHistoryLog
	| AssignCoachSetSearchValueAction
	| AssignCoachSelectAction
	| AssignCoachSetLoadingStateAction
	| AssignCoachesResetAction
